import ResumenBodegaContainer from './ResumenBodegaContainer';
export default ResumenBodegaContainer;
